<script setup>
import { LogOut } from 'lucide-vue-next'
</script>

<template>
  <LogOut />
</template>
